export const ESB_AUDIT_LOG_RESET_STATE = 'ESB_AUDIT_LOG_RESET_STATE';
export const ESB_AUDIT_LOG_CURRENT_ITEM = 'ESB_AUDIT_LOG_CURRENT_ITEM';

export const ESB_AUDIT_LOG_REQUEST_LOADING = 'ESB_AUDIT_LOG_REQUEST_LOADING';
export const ESB_AUDIT_LOG_REQUEST_SUCCESS = 'ESB_AUDIT_LOG_REQUEST_SUCCESS';
export const ESB_AUDIT_LOG_REQUEST_FAILED = 'ESB_AUDIT_LOG_REQUEST_FAILED';

export const ESB_AUDIT_LOG_CURRENT_ACTION = 'ESB_AUDIT_LOG_CURRENT_ACTION';
export const ESB_AUDIT_LOG_RESET_ACTION = 'ESB_AUDIT_LOG_RESET_ACTION';